<template>
  <!-- 律师预约 -->
  <div class="eprights-cont">
    <div class="left-tabs">
      <a class="active" @click="gotoAppoint">律师预约</a>
      <a @click="gotoHistory">历史预约</a>
    </div>
    <div class="right-laws">
      <h3 class="titleh3">填写申请信息</h3>
      <div class="applay-info">
        <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            class="calendarbox"
            v-show="stepFlag === 1"
        >
          <a-form-model-item ref="title" label="标题名称" prop="title">
            <a-input
              v-model="form.title"
              @blur="
                () => {
                  $refs.title.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <!-- <a-form-model-item label="预约时间" prop="appoint_time">
          <a-date-picker @change="onChangeTime" v-model="form.appoint_time" value="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width: 100%;"/>
        </a-form-model-item> -->
          <a-form-model-item label="预约事项" prop="appoint_matter">
            <!-- <a-input v-model="form.appoint_matter" /> -->
             <a-textarea
                 v-model="form.appoint_matter"
                 placeholder="请填写"
                 :auto-size="{ minRows: 2, maxRows: 5 }"
             />
          </a-form-model-item>
          <a-form-model-item label="姓名" prop="creator_name">
            <a-input v-model="form.creator_name"/>
          </a-form-model-item>
          <a-form-model-item label="手机号码" prop="creator_mobile_number">
            <a-input v-model="form.creator_mobile_number"/>
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="creator_certificate_number">
            <a-input v-model="form.creator_certificate_number"/>
          </a-form-model-item>
          <a-form-model-item label="工作单位" prop="creator_work_organization">
            <a-input v-model="form.creator_work_organization"/>
          </a-form-model-item>
          <a-form-model-item label="事件发生地" prop="matter_site">
            <a-input v-model="form.matter_site"/>
          </a-form-model-item>
          <a-form-model-item label="提交对象" prop="accept_unit_id">
            <a-cascader
                :options="unitOptions"
                change-on-select
                v-model="form.accept_unit_id"
                placeholder="请选择"
                @change="changeUnit"
            ></a-cascader>
          </a-form-model-item>

          <a-form-model-item ref="name" label="预约时间" prop="appoint_time">
            <div
                :style="{
                width: '300px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
              }"
            >
              <a-calendar
                  :fullscreen="false"
                  value="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  @panelChange="onPanelChange"
                  @select="onSelectDate"
                  :disabledDate="disabledDate"
                  v-model="form.appoint_time"
                  :locale="locale"
              />
            </div>
          </a-form-model-item>
          <a-form-model-item label="时间段" prop="ampm">
            <div class="timebox">

              <div class="time-content" v-if="timeslotList.length > 0">
                <a-radio-group v-model="form.ampm" @change="onChange">
                  <a-radio
                      :style="radioStyle"
                      :value="item.ampm"
                      v-for="(item, index) in timeslotList"
                      :key="index"
                  >
                    {{ item.start_time }}-{{ item.end_time }}
                    <i>{{ item.ampm === 1 ? '上午' : '下午' }}</i>
                  </a-radio>
                </a-radio-group>
              </div>
              <p v-else>暂不开放</p>
            </div>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ span: 24}">
            <span style="padding-left: 90px;">
              申请须知：申请人申请律师服务面对面不可指定律师，由当日现场值班律师进行接待。
            </span>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="onSubmit2"> 提交</a-button>
          </a-form-model-item>
          <!--          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">-->
          <!--            <a-button type="primary" @click="nextClick"> 下一步 </a-button>-->
          <!--          </a-form-model-item>-->
        </a-form-model>
        <!--        <a-form-model-->
        <!--          ref="timeForm"-->
        <!--          :model="form"-->
        <!--          :rules="rules"-->
        <!--          :label-col="labelCol"-->
        <!--          :wrapper-col="wrapperCol"-->
        <!--          class="calendarbox"-->
        <!--          v-show="stepFlag === 2"-->
        <!--        >-->
        <!--          <a-form-model-item ref="name" label="预约时间" prop="appoint_time">-->
        <!--            <div-->
        <!--              :style="{-->
        <!--                width: '300px',-->
        <!--                border: '1px solid #d9d9d9',-->
        <!--                borderRadius: '4px',-->
        <!--              }"-->
        <!--            >-->
        <!--              <a-calendar-->
        <!--                :fullscreen="false"-->
        <!--                value="YYYY-MM-DD"-->
        <!--                valueFormat="YYYY-MM-DD"-->
        <!--                @panelChange="onPanelChange"-->
        <!--                @select="onSelectDate"-->
        <!--                :disabledDate="disabledDate"-->
        <!--                v-model="form.appoint_time"-->
        <!--                :locale="locale"-->
        <!--              />-->
        <!--            </div>-->
        <!--          </a-form-model-item>-->
        <!--          <a-form-model-item label="时间段" prop="ampm">-->
        <!--            <div class="timebox">-->
        <!--              &lt;!&ndash; <div class="time-title">-->
        <!--              <span>选择预约时间</span>-->
        <!--            </div> &ndash;&gt;-->
        <!--              <div class="time-content" v-if="timeslotList.length > 0">-->
        <!--                <a-radio-group v-model="form.ampm" @change="onChange">-->
        <!--                  <a-radio-->
        <!--                    :style="radioStyle"-->
        <!--                    :value="item.ampm"-->
        <!--                    v-for="(item, index) in timeslotList"-->
        <!--                    :key="index"-->
        <!--                  >-->
        <!--                    {{ item.start_time }}-{{ item.end_time }}-->
        <!--                    <i>{{ item.ampm === 1 ? '上午' : '下午' }}</i>-->
        <!--                  </a-radio>-->
        <!--                </a-radio-group>-->
        <!--              </div>-->
        <!--              <p v-else>暂不开放</p>-->
        <!--            </div>-->
        <!--          </a-form-model-item>-->
        <!--          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">-->
        <!--            <a-button type="primary" @click="onSubmit"> 提交 </a-button>-->
        <!--            <a-button @click="resetForm"> 返回 </a-button>-->
        <!--          </a-form-model-item>-->
        <!--        </a-form-model>-->
        <div class="submitResult" v-show="stepFlag === 3">
          <div class="success-box" v-if="successShow">
            <i class="iconfont">&#xe664;</i>
            <p>提交成功</p>
          </div>
          <div class="fail-box" v-else>
            <i class="iconfont">&#xe66b;</i>
            <p>提交失败</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/zh-cn';
import {getCurrentUser} from '@/api/login';
import {getDept, getLawyerAppointtime, getLawyerServiceAdd,} from '@/api/index.js';
import {Modal} from "ant-design-vue";

export default {
  name: 'LAppoint',
  data() {
    const validateNameCheck = (rule, value, callback) => {
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (num > 20) {
        callback(new Error('标题最多20个文字！'))
      } else {
        callback()
      }
    };
    const validatePhoneCheck = (rule, value, callback) => {
      // 定义正则表达式
      const phoneRegex = /^(?:1(?:3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-9]))\d{8}$/
      let num =0;
      num=value.length;
      // for (var i = 0; i < value.length; i++) {
      //   if (/[\u4e00-\u9fa5]/.test(value[i])) {
      //     num += 2
      //   } else {
      //     num++
      //   }
      // }
      // console.log(num)
      if (!phoneRegex.test(value)) {
        callback(new Error('手机号码校验不正确！'))
      } else {
        callback()
      }
    };
    return {
      accept_unit_id: [],
      stepFlag: 1,
      disabledDate: (current) => {
        return current && current < moment().endOf('day'); //当天之前的不可选，包括当天
      },
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      locale: {
        lang: {
          month: '月',
          year: '年',
        },
      },
      form: {
        title: '', //标题
        appoint_time: null, //预约时间
        appoint_matter: '', //预约事项
        creator_mobile_number: '', //手机号\
        creator_certificate_number: '',
        creator_name: '', //姓名
        creator_work_organization: '', //工作单位
        matter_site: '', //事件发生地
        accept_unit_id: [], //提交对象
        ampm: null,
      },
      unit_id: '',
      unitOptions: [],
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' },{ validator: validateNameCheck, trigger: 'blur' }],
        appoint_time: [
          { required: true, message: '请选择预约时间', trigger: 'change' },
        ],
        appoint_matter: [
          {required: true, message: '请输入预约事项', trigger: 'blur'},
        ],
        creator_mobile_number: [
          {required: true, message: '请输入手机号', trigger: 'blur'}, {validator: validatePhoneCheck, trigger: 'blur'}
        ],
        creator_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        creator_certificate_number: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
        ],
        creator_work_organization: [
          {required: true, message: '请输入工作单位', trigger: 'blur'},
        ],
        matter_site: [
          {required: true, message: '请输入事件发生地', trigger: 'blur'},
        ],
        accept_unit_id: [
          {required: true, message: '请选择提交对象', trigger: 'change'},
        ],
        ampm: [{required: true, message: '请选择时间段', trigger: 'change'}],
      },
      timeslotList: [], //时间段数组
      value: '', //默认时间段值
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      successShow: true,
      treeData: [],
    };
  },
  //
  created() {

  },

  mounted() {
    let webId = JSON.parse(localStorage.getItem('webid'))
    if(webId == null){
      this.form.accept_unit_id = []
    }else if(webId == "1"){
      this.form.accept_unit_id = ["32"]
    }else{
      this.form.accept_unit_id = ["32",`${webId}`]
    }
    this.getDept();
    this.init();
    this.$forceUpdate()
    // this.getLawyerAppointtime()

  },
  //

  methods: {
    init() {
      getCurrentUser().then((res) => {
        debugger
        this.form.creator_name = res.name;

        if (res.mobile) {
          this.form.creator_mobile_number = res.mobile;
        }
        if (res.cardid) {
          this.form.creator_certificate_number = res.cardid;
        }

      });
    },
    getLawyerAppointtime() {
      getLawyerAppointtime({unit_id:this.form.accept_unit_id}).then((res) => {
        this.timeslotList = res;
      });
    },
    getDept() {
      getDept().then((res) => {
        console.log(res)
        // console.log(res);
        this.unitOptions = res;
      });
    },
    onSubmit() {
      this.$refs.timeForm.validate((valid) => {
        if (valid) {
          this.form.accept_unit_id = this.form.accept_unit_id[this.form.accept_unit_id.length-1]
          getLawyerServiceAdd(this.form)
            .then((res) => {
              console.log(res);
              // this.$refs.ruleForm.resetFields();
              this.stepFlag = 3;
              this.successShow = true;
              setTimeout(() => {
                this.$router.push('/LawyerArea');
              }, 2000);
            })
              .catch((err) => {
                this.stepFlag = 3;
                this.successShow = false;
              });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onSubmit2() {
      console.log(this.$refs.ruleForm, this.form)
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.accept_unit_id = this.form.accept_unit_id[this.form.accept_unit_id.length - 1]
          getLawyerServiceAdd(this.form)
              .then((res) => {
                console.log(res);
                // this.$refs.ruleForm.resetFields();
                this.stepFlag = 3;
                this.successShow = true;
                setTimeout(() => {
                  this.$router.push('/LawyerArea');
                }, 2000);
              })
              .catch((err) => {
                this.stepFlag = 3;
                this.successShow = false;
              });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.stepFlag = 1;
    },
    gotoHistory: function () {
      this.$router.push({name: 'HistoryAppoint'});
    },
    onPanelChange(value, mode) {
      console.log(value, mode);
    },
    onSelectDate(value) {
      debugger
      this.timeslotList = [];
      let unitId = this.form.accept_unit_id[this.form.accept_unit_id.length - 1]

      if (!unitId) {
        Modal.warning({content: "请先选择提交对象"});
        return;
      }

      getLawyerAppointtime({unit_id: unitId, starttime: value, endtime: value}).then((res) => {
        this.form.appoint_time = value;
        //取消时间的必填
        this.$refs.ruleForm.validate()
        res.map((item) => {
          // let temp = item.appoint_date.slice(0, 10);
          // if (value === temp) {
          this.timeslotList.push(item);
          // }
        });
      });
    },
    selectUnitClick(v) {
      console.log(v);
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    },
    onChangeTime(date, dateString) {
      console.log(date, dateString);
    },
    nextClick() {
      this.$refs.ruleForm.validate((valid, errs) => {
        if (valid) {
          this.stepFlag = 2;
        }
      });
    },
    nextClick1() {
      this.stepFlag = 3;
    },
    changeUnit(ids) {
      // this.form.accept_unit_id = ids[ids.length - 1];
    },
    gotoAppoint() {
      this.$router.push({ name: 'LAppoint' });
    },
  },
};
</script>
<style scoped>
.eprights-cont {
  display: flex;
}
.left-tabs {
  width: 260px;
  text-align: center;
  padding-top: 20px;
}
.left-tabs a {
  display: inline-block;
  width: 220px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 18px;
  color: #666;
  background: #fafbfc;
  border: 1px solid #d9dfe8;
  box-sizing: border-box;
}
.left-tabs a + a {
  margin-top: 10px;
}
.left-tabs a.active {
  color: #0079df;
  background: #f3f9ff;
  border: 1px solid #78c1ff;
}
.right-laws {
  flex: 1;
  padding-top: 10px;
  padding-right: 20px;
}
.applay-info {
  border: 1px solid #d9dfe8;
}
.m-applay {
  margin-bottom: 0;
  padding: 15px 20px;
}
.m-applay li {
  list-style: none;
  line-height: 35px;
}
span.red {
  color: #f00;
}
.applay-info .ant-form {
  padding-top: 20px;
}
.timebox {
  width: 360px;
}
.timebox .time-title {
  display: flex;
  border-bottom: 1px solid #ddd;
}
.timebox .time-title span {
  width: 180px;
  text-align: center;
}
.applay-info >>> .calendarbox .ant-select {
  width: auto !important;
}
.applay-info >>> .ant-radio-wrapper {
  margin-bottom: 10px;
}
.ant-radio-group {
  width: 100%;
}
.time-content {
  padding: 0 10px;
}
.time-content i {
  font-style: normal;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  line-height: 20px;
  color: #1890ff;
  background: #e6f7ff;
  border-color: #91d5ff;
  padding: 0 5px;
  border-radius: 4px;
  margin-left: 10px;
}
.time-content .count {
  width: 130px;
  float: right;
  text-align: center;
}
.submitResult {
  text-align: center;
  padding: 20px 0;
}
.submitResult .iconfont {
  font-size: 50px;
}
.success-box {
  color: #87d068;
}
.fail-box {
  color: #f00;
}
.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>
